// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e73539b7","453":"a024fcf2","455":"9ad429fd","977":"fca810fb"}[chunkId] + ".chunk.js";
};